export default __webpack_public_path__ + "static/media/Curso-Excel-Inicial.6d33182b.png";